import { Component, OnInit } from '@angular/core';
import { PrivateSectorService } from 'src/app/services/private-sector.service';

@Component({
  selector: 'app-private-sector',
  templateUrl: './private-sector.component.html',
  styleUrls: ['./private-sector.component.css']
})
export class PrivateSectorComponent implements OnInit {

  subcategories$

  constructor(private privateSectorService: PrivateSectorService) { 
    this.subcategories$ = this.privateSectorService.getSubCategories();
  }

  ngOnInit() {
  }

}
